import React from 'react';
import { SitecoreContextReactContext } from '../components/SitecoreContext';
/**
 * @param {WithSitecoreContextOptions} [options]
 */
export function withSitecoreContext(options) {
    return function withSitecoreContextHoc(Component) {
        return function WithSitecoreContext(props) {
            return (React.createElement(SitecoreContextReactContext.Consumer, null, (context) => (React.createElement(Component, Object.assign({}, props, { sitecoreContext: context.context, updateSitecoreContext: options && options.updatable && context.setContext })))));
        };
    };
}
/**
 * This hook grants acсess to the current Sitecore page context
 * by default JSS includes the following properties in this context:
 * - pageEditing - Provided by Layout Service, a boolean indicating whether the route is being accessed via the Experience Editor.
 * - pageState - Like pageEditing, but a string: normal, preview or edit.
 * - site - Provided by Layout Service, an object containing the name of the current Sitecore site context.
 * @see https://jss.sitecore.com/docs/techniques/extending-layout-service/layoutservice-extending-context
 * @param {WithSitecoreContextOptions} [options] hook options
 * @example
 * const EditMode = () => {
 *    const { sitecoreContext } = useSitecoreContext();
 *    return <span>Edit Mode is {sitecoreContext.pageEditing ? 'active' : 'inactive'}</span>
 * }
 * @example
 * const EditMode = () => {
 *    const { sitecoreContext, updateSitecoreContext } = useSitecoreContext({ updatable: true });
 *    const onClick = () => updateSitecoreContext({ pageEditing: true });
 *    return <span onClick={onClick}>Edit Mode is {sitecoreContext.pageEditing ? 'active' : 'inactive'}</span>
 * }
 * @returns {object} { sitecoreContext, updateSitecoreContext }
 */
export function useSitecoreContext(options) {
    const reactContext = React.useContext(SitecoreContextReactContext);
    const updatable = options === null || options === void 0 ? void 0 : options.updatable;
    return {
        sitecoreContext: reactContext.context,
        updateSitecoreContext: updatable ? reactContext.setContext : undefined,
    };
}
